import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="language_id"
				reference="languages"
				alwaysOn
				fullWidth
				emptyText="ra.action.allf"
				filter={{ is_frontend: true }}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
		</SubmitFilters>
	);
};
export default Filters;
